import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-verify-borrower-modal',
  imports: [BaseModalComponent, ReactiveFormsModule, MatIconModule, MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './verify-borrower-modal.component.html',
  styleUrl: './verify-borrower-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyBorrowerModalComponent {
  private readonly fb = inject(FormBuilder);
  private readonly transloco = inject(TranslocoService);

  readonly title = input<string>(this.transloco.translate('commonMessagesVerifyIdentity'));

  readonly description = input<string>(this.transloco.translate('modalsVerifyBorrowerDescription'));

  readonly verify = output<string>();

  readonly cancel = output<void>();

  protected readonly isLoading = signal(false);

  protected readonly errorMessage = signal<string | null>(null);

  protected readonly ssnForm = this.fb.group({
    ssn: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern(/^\d{4}$/)]],
  });

  protected onVerify(): void {
    if (!this.ssnForm.valid) return;

    const ssn = this.ssnForm.get('commonFieldsSsn')?.value || '';
    this.verify.emit(ssn);
  }

  protected onCancel(): void {
    this.cancel.emit();
  }

  setError(message: string): void {
    this.errorMessage.set(message);
    this.isLoading.set(false);
  }

  setLoading(loading: boolean): void {
    this.isLoading.set(loading);
  }
}
